import { render, staticRenderFns } from "./AbstractEditorPopup.vue?vue&type=template&id=a01a56f6&scoped=true&"
import script from "./AbstractEditorPopup.vue?vue&type=script&lang=js&"
export * from "./AbstractEditorPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01a56f6",
  null
  
)

export default component.exports